import React,{ FC } from "react";
import { NavLink } from "react-router-dom";
import { useUser } from "store/utils/hooks";

export interface CommonLayoutProps {
  children?: React.ReactNode;
  noContainer?: boolean
}

const CommonLayout: FC<CommonLayoutProps> = ({ children, noContainer = false }) => {
  const user = useUser();
  return (
    <div className={`nc-CommonLayoutProps ${noContainer ? '' : 'container'}`}>
      <div className="mt-14 sm:mt-20">
        <div className=" mx-auto">
          <div className="max-w-2xl">
            <h2 className="text-3xl xl:text-4xl font-semibold">Mi cuenta</h2>
            <span className="block mt-4 text-neutral-500 dark:text-neutral-400 text-base sm:text-lg">
              <span className="text-slate-900 dark:text-slate-200 font-semibold">
                {user?.username},
              </span>{" "}
              {user?.email}
            </span>
          </div>
          <hr className="mt-10 border-slate-200 dark:border-slate-700"></hr>

          <div className="flex space-x-8 md:space-x-14 overflow-x-auto hiddenScrollbar">
            {[
              {
                name: "Detalles de la cuenta",
                link: "/account",
              },
              {
                name: "Tus Datos",
                link: "/addresses",
              },
              {
                name: "Estudiantes",
                link: "/students"
              },
              {
                name: " Mis Pedidos",
                link: "/account-my-order",
              },
              {
                name: "Mi lista de espera",
                link: '/account-wait-list'
              },
              // {
              //   name: "Cambiar contraseña",
              //   link: "/account-change-password",
              // },
              {
                name: "Eliminar cuenta",
                link: "/account-remove",
              },
            ].map((item, index) => (
              <NavLink
                key={index}
                to={item.link}
                className={({ isActive }) =>
                  `block py-5 md:py-8 border-b-2 border-transparent flex-shrink-0  text-sm sm:text-base ${
                    isActive
                      ? "border-primary-500 font-medium text-slate-900 dark:text-slate-200"
                      : "text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200"
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
          </div>
          <hr className="border-slate-200 dark:border-slate-700"></hr>
        </div>
      </div>
      <div className="mx-auto pt-14 sm:pt-26 pb-24 lg:pb-32">
        {children}
      </div>
    </div>
  );
};

export default CommonLayout;
